export default "__VITE_PUBLIC_ASSET__ef0e2f2e__"